const ADD_CANBUSTYPES = 'ADD_CANBUSTYPES'
const ADD_TRANSLATIONS = 'ADD_TRANSLATIONS'
const ADD_ERRORS = 'ADD_ERRORS'
const SET_FETCH_TRANSLATE_SUCCESS = 'SET_FETCH_TRANSLATE_SUCCESS'
const SET_FETCH_PROCESS_SUCCESS = 'SET_FETCH_PROCESS_SUCCESS'
const SET_DEVICE_SERIAL_NUMBER = 'SET_DEVICE_SERIAL_NUMBER'
const SET_RMA_DEVICE_SERIAL_NUMBER = 'SET_RMA_DEVICE_SERIAL_NUMBER'
const SET_LICENSE_PLATE = 'SET_LICENSE_PLATE'

const SET_TANK_SIZE = 'SET_TANK_SIZE'
const SET_CHOOSED_PROPERTY_TYPE = 'SET_CHOOSED_PROPERTY_TYPE'
const SET_WFSUBSCRIPTION = 'SET_WFSUBSCRIPTION'
const SET_TARIFFS = 'SET_TARIFFS'
const SET_RMA_DEVICES = 'SET_RMA_DEVICES'
const SET_CONTRACT_NUMBER = 'SET_CONTRACT_NUMBER'
const SET_ACTIVATION_CODE = 'SET_ACTIVATION_CODE'
const SET_CUSTOMER_NUMBER = 'SET_CUSTOMER_NUMBER'
const SET_DEVICE_ACTIVATION_KEY = 'SET_DEVICE_ACTIVATION_KEY'
const SET_SUBSCRIPTION_SELECTED_PAGE = 'SET_SUBSCRIPTION_SELECTED_PAGE'
const SET_SELECTED_SUBSCRIPTION_OPTION = 'SET_SELECTED_SUBSCRIPTION_OPTION'
const SET_PROVIDER_NO = 'SET_PROVIDER_NO'
const SET_IS_DAK_DEVICE = 'SET_IS_DAK_DEVICE'
// USED ONLY TO DETERMINE IS GENERATION CHOOSE REQUIRED DURING ACTIVATION PROCESS
const SET_GENERATION_REQUIRED = 'SET_GENERATION_REQUIRED'

// VEHICLE GENERATION SELECTION MODULE

const SET_VEHICLE_GENERATION_NO = 'SET_VEHICLE_GENERATION_NO'
const SET_BRANDS = 'SET_BRANDS'
const SET_MODELS = 'SET_MODELS'
const SET_GENERATIONS = 'SET_GENERATIONS'
const SET_GENERATION_SELECTED = 'SET_GENERATION_SELECTED'
const SET_GENERATION_OBJECT = 'SET_GENERATION_OBJECT'
const SET_BRAND_ID = 'SET_BRAND_ID'
const SET_MODEL_ID = 'SET_MODEL_ID'
const SET_FUELTYPE_INDEX = 'SET_FUELTYPE_INDEX'
const SET_FUELTYPES_GROUP = 'SET_FUELTYPES_GROUP'
const SET_GENERATION_ID_SELECTED = 'SET_GENERATION_ID_SELECTED'

export {
    ADD_CANBUSTYPES,
    ADD_TRANSLATIONS,
    ADD_ERRORS,
    SET_FETCH_PROCESS_SUCCESS,
    SET_FETCH_TRANSLATE_SUCCESS,
    SET_ACTIVATION_CODE,
    SET_BRANDS,
    SET_DEVICE_ACTIVATION_KEY,
    SET_DEVICE_SERIAL_NUMBER,
    SET_BRAND_ID,
    SET_CHOOSED_PROPERTY_TYPE,
    SET_CONTRACT_NUMBER,
    SET_CUSTOMER_NUMBER,
    SET_FUELTYPES_GROUP,
    SET_RMA_DEVICES,
    SET_LICENSE_PLATE,
    SET_RMA_DEVICE_SERIAL_NUMBER,
    SET_WFSUBSCRIPTION,
    SET_TARIFFS,
    SET_SELECTED_SUBSCRIPTION_OPTION,
    SET_SUBSCRIPTION_SELECTED_PAGE,
    SET_PROVIDER_NO,
    SET_IS_DAK_DEVICE,
    SET_GENERATIONS,
    SET_GENERATION_REQUIRED,
    SET_VEHICLE_GENERATION_NO,
    SET_MODELS,
    SET_GENERATION_ID_SELECTED,
    SET_GENERATION_OBJECT,
    SET_GENERATION_SELECTED,
    SET_MODEL_ID,
    SET_FUELTYPE_INDEX,
    SET_TANK_SIZE
}
